import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <p className="text-foreground-500 text-xs md:text-sm font-medium tracking-wider uppercase mb-2">
            Unsere Top-Kategorien
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            Entdecke mehr <br />
            <span className="font-script text-primary-500 text-3xl md:text-5xl">OOPBuy Finds</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-white rounded-2xl overflow-hidden hover:scale-[1.02] transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${cat.icon} text-sm text-foreground-500`}></i>
                  </div>
                  <span className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}